import React, { useState, useEffect } from 'react';
import './QuizQuestion.css';
import AudioPlayer from './AudioPlayer';

const QuizQuestion = ({ question, answers, correctAnswer, onAnswerClick, isLocked, feedback, image, sound }) => {
  const [selectedAnswer, setSelectedAnswer] = useState(null);

  // Réinitialiser selectedAnswer lorsque la question ou les réponses changent
  useEffect(() => {
    setSelectedAnswer(null);
  }, [question, answers]);

  const handleAnswer = (index) => {
    if (isLocked || selectedAnswer !== null) return;
    setSelectedAnswer(index);
    onAnswerClick(index);
  };

  const determineClass = (index) => {
    if (selectedAnswer === null) return 'answer-button';
    if (index === correctAnswer) return 'correct-answer';
    if (index === selectedAnswer && selectedAnswer !== correctAnswer) return 'incorrect-answer';
    return 'incorrect-answer-unselected';
  };

  // Fonction pour déterminer le texte alternatif
  const getAltText = (imagePath) => {
    if (imagePath && imagePath.endsWith('.svg') && imagePath.includes('/images/Drapeau/')) {
      return 'Drapeau associé à la question';
    }
    return 'Tableau associé à la question';
  };

  // Fonction pour déterminer si l'image est un drapeau
  const isFlag = (imagePath) => {
    return imagePath && imagePath.endsWith('.svg') && imagePath.includes('/images/Drapeau/');
  };

  // Fonction pour déterminer la classe CSS en fonction du type d'image
  const getImageClass = (imagePath) => {
    return isFlag(imagePath) ? "flag-image" : "painting-image";
  };

  // Fonction pour déterminer la classe du conteneur
  const getFrameClass = (imagePath) => {
    return isFlag(imagePath) ? "flag-container" : "painting-frame";
  };

  // Vérifier s'il y a un média (image ou son)
  const hasMedia = image || sound;

  return (
    <div className="quiz-question">
      <div className={`quiz-content ${!hasMedia ? 'no-media' : ''}`}>
        {/* Colonne de gauche : Image et Audio */}
        {hasMedia && (
          <div className="quiz-media">
            {image && (
              <div className={getFrameClass(image)}>
                <img
                  src={image}
                  alt={getAltText(image)}
                  className={getImageClass(image)}
                />
              </div>
            )}
            {sound && <AudioPlayer sound={sound} />}
          </div>
        )}

        {/* Colonne de droite : Question et Réponses */}
        <div className="quiz-text">
          <p className="question-text">{question}</p>
          <ul className="answers-container">
            {answers.map((answer, index) => (
              <li
                key={index}
                onClick={() => handleAnswer(index)}
                className={determineClass(index)}
              >
                {answer}
              </li>
            ))}
          </ul>
        </div>
      </div>

      {/* Feedback en dessous */}
      {feedback && (
        <div className={`answer-feedback ${feedback.isCorrect ? 'correct' : 'incorrect'}`}>
          <p>
            <span>{feedback.isCorrect ? '✅ Bonne réponse !' : '❌ Mauvaise réponse !'}</span>
            <br />
            <span className="feedback-info">{feedback.message}</span>
          </p>
        </div>
      )}
    </div>
  );
};

export default QuizQuestion;